angular.module('bizmetryApp').controller('LogDetailDialogController', function($scope, $mdDialog, log) {
  $scope.log = log;

  $scope.closeDialog = function () {
    $mdDialog.hide();
  };

  $scope.formatTimestamp = function (ts) {
    const date = new Date(ts);
    return isNaN(date.getTime()) ? 'N/A' : date.toISOString().replace('T', ' ').slice(0, -1);
  };

  $scope.payloadCopied = false;

$scope.copyPayload = function () {
    if (!$scope.log || !$scope.log.logMessage) return;

    navigator.clipboard.writeText($scope.log.logMessage).then(function () {
        $scope.$apply(function () {
            $scope.payloadCopied = true;
        });
        $timeout(function () {
            $scope.payloadCopied = false;
        }, 2000);
    }).catch(function () {
        // fallback para browsers sin clipboard API
        var el = document.createElement('textarea');
        el.value = $scope.log.logMessage;
        el.style.position = 'fixed';
        el.style.opacity = '0';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        $scope.$apply(function () { $scope.payloadCopied = true; });
        $timeout(function () { $scope.payloadCopied = false; }, 2000);
    });
};
});
